import { mergeClasses } from 'minimal-shared/utils';
import { useState } from 'react';

import { styled } from '@mui/material/styles';

import { flagIconClasses } from './classes';

// ----------------------------------------------------------------------

export type FlagIconProps = React.ComponentProps<typeof FlagRoot> & {
  code?: string;
};

export function FlagIcon({ code, className, sx, ...other }: FlagIconProps) {
  const [loadError, setLoadError] = useState(false);
  const upperCode = code?.toUpperCase?.() ?? '';
  if (!upperCode) return null;

  return (
    <FlagRoot className={mergeClasses([flagIconClasses.root, className])} sx={sx} {...other}>
      {!loadError ? (
        <FlagImg
          loading="lazy"
          alt={upperCode}
          src={`https://purecatamphetamine.github.io/country-flag-icons/3x2/${upperCode}.svg`}
          className={flagIconClasses.img}
          onError={() => setLoadError(true)}
        />
      ) : (
        <FlagFallback aria-label={upperCode}>{upperCode}</FlagFallback>
      )}
    </FlagRoot>
  );
}

// ----------------------------------------------------------------------

const FlagRoot = styled('span')(({ theme }) => ({
  width: 26,
  height: 20,
  flexShrink: 0,
  overflow: 'hidden',
  borderRadius: '5px',
  alignItems: 'center',
  display: 'inline-flex',
  justifyContent: 'center',
  backgroundColor: theme.vars.palette.background.neutral,
}));

const FlagImg = styled('img')(() => ({
  width: '100%',
  height: '100%',
  maxWidth: 'unset',
  objectFit: 'cover',
}));

const FlagFallback = styled('span')(({ theme }) => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: 11,
  fontWeight: 700,
  color: theme.vars?.palette?.text?.secondary ?? theme.palette.text.secondary,
  textTransform: 'uppercase',
}));
